// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ovnH","col":"styles_col__c5KBd"};